
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classes",
      function () {
        return require("private-next-pages/classes/index.js");
      }
    ]);
  